import Vue from 'vue'
import axios from 'axios';
import router from '../../router';
import store from 'vuex';
import {
  devUrl,
  config,
  defaultPlat
} from '../../config.js';
let toast_num = 0 //弹窗弹出次数
class Common {
  constructor() {
    let $url = 'https://' + window.location.host;
    let $config = defaultPlat;
    if (config.has($url)) {
      $config = config.get($url);
    } else {
      $config.url = $url;
    }
    if (process.env.NODE_ENV === 'development') {
      $config.url = devUrl;
    } else {
      console.oldlog = console.log;
      console.log = function() {
        return
      }
    }

    $config.isNewOss = defaultPlat.ali_url != $config.ali_url; //当前服务器是否和默认oss一致，在选择跨平台图片使用判断

    Vue.prototype.$projectType = $config.projectType || 0;
    Vue.prototype.$config = $config;
    Vue.prototype.url = $config.url;
    Vue.prototype.img_zoom = '?x-oss-process=image/resize,p_30'; //阿里云图片转缩略图
    Vue.prototype.verifyPhone = $config.verifyPhone;
    Vue.prototype.loading = true;
    Vue.prototype.limit = 20; //页大小
    this.system_version = 2; //2新版本放manager 1老版本managerv2

    this._init()
  }
  /*
   * 初始化所有方法
   */
  _init() {
    /*
     * 请求简化方法 使用方法如下：
     * this.request({
     *   url:'请求链接',可不写域名默认会加上平台域名即设置的全局域名
     *   method:'请求方法',
     *   data:{请求数据},
     *   is_public:是否需要公共参数,可写可不写,默认false
     *   success:(res)=>{},可写可不写
     *   fail:(res)=>{},可写可不写
     *   complete:(res)=>{}可写可不写
     * })
     */
    this._setRequest()

    this._setExcel();
  }
  /*
   * 简化请求方法
   */
  _setRequest() {
    Vue.prototype.request = function(obj) {
      let {
        url = '', //请求链接
          method = 'POST', //请求方式
          data = {}, //请求参数
          is_public = false, //是否需要公共参数
          headers = {
            'Content-Type': 'application/json;charset=UTF-8'
          }, //请求头设置
          success, //成功回调
          fail, //失败回调
          complete, //接口成功请求回调
          onUploadProgress
      } = obj;
      const reg = new RegExp("^http");
      const is_domainName = url.match(reg);
      let request_url = url;
      if (!is_domainName) {
        request_url = Vue.prototype.url + request_url;
      }
      if (data.language === undefined) {
        data.language = Vue.prototype.$bus.$i18n.locale.toLocaleLowerCase();
      }
      if (is_public) {
        let user_info = Vue.prototype.getSessionStorage('user_info');
        data.token = user_info.access_token;
        data.plat_id = data.plat_id ? data.plat_id : user_info.plat_id;
        data.uid = user_info.uid;
        data.access_token = user_info.access_token;
        if (!data.appid) {
          data.appid = user_info.appid;
        }
        if (!data.token) {
          this.$router.push('/login');
          return
        }
      }
      axios({
        method: method,
        async: false,
        url: request_url,
        headers: headers,
        data: data,
        onUploadProgress: function(progressEvent) {
          onUploadProgress && onUploadProgress(progressEvent)
        },
        is_public
      }).then(res => {
        let times = 0;
        if (res.data.error_code == 0) {
          times = new Date().getTime();
          success && success(res.data);
        } else {
          if (res.data.error_code == 401) {
            if (toast_num == 0) {
              toast_num++
              Vue.prototype.$message.error(Vue.prototype.$bus.$ts('当前账号已在其它地方登陆，请重新登陆'));
              setTimeout(() => {
                toast_num = 0
                location.reload()
                // router.push('/login')
              }, 5000)
            }
            Vue.prototype.clearStorage('user_info')
            return false
          }else if (res.data.error_code == 1) {
            if (res.data.error_msg == '会话不存在') {
              location.reload()
              this.$router.push('/login');
            }
          }
        }
        if (this.$store && this.$store.commit) {
          this.$store.commit('setRequestTimes', {
            name: url,
            value: times
          })
        }
        if (complete) {
          complete(res.data || res);
        } else if (res.data.error_code != 0) {
          if (fail) {
            fail(res.data)
          } else {
            Vue.prototype.$message.error(res.data.error_msg);
          }
        }
      }).catch(err => {
        fail && fail(err);
      });
    }

    // Vue.prototype.requestOther = function(obj) {
    //   let {
    //     url = '', //请求链接
    //       method = 'GET', //请求方式
    //       data = {}, //请求参数
    //       headers = {
    //         'Content-Type': 'application/json;charset=UTF-8'
    //       }, //请求头设置
    //       complete, //接口成功请求回调
    //   } = obj;
    //   const reg = new RegExp("^http");
    //   const is_domainName = url.match(reg);
    //   axios({
    //     method: method,
    //     url: url,
    //     headers: headers,
    //     data: data,
    //   }).then(complete).catch(complete);
    // }
  }
  /*
   * 导出方法excel  tHeader: excel头部  filterVal: 头部对应的值 data： 导出的数据 title： 文件名字
   */
  _setExcel() {
    Vue.prototype.exportExcel = (tHeader, filterVal, data, title) => {
      require.ensure([], () => {
        const {
          export_json_to_excel
        } = require('../../vendor/Export2Excel');
        data = data.map(v => filterVal.map(j => v[j]))
        export_json_to_excel(tHeader, data, title);
      })
    }
  }
}

Vue.prototype.common = new Common() //创建并挂载属性和方法



// WEBPACK FOOTER //
// ./src/assets/js/common.js